

import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '~src/commonInfra/L10n/L10n';
import {HelpService} from '~src/commonInfra/services/HelpService';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';

import { IApproveClusterNodeResult } from '../../serverApi/requests/ApproveClusterNodeRequest';
import { BaasEdgePoolAndCluster } from '../../serverApi/resources/BaasEdgePoolAndCluster';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';
import { AcceptClusterNodeButtonProps } from './AcceptClusterNodeButton';


export function openAcceptClusterNodeDialog(props: AcceptClusterNodeButtonProps) {
    const { node, clusterId, siteId } = props;
    const dialogInstance = openReactConfirmationDialog({
      title: Messages.dataConnectSiteSettingsAcceptClusterNodeButton(),
      message: Messages.dataConnectSiteSettingsAcceptClusterNodeDescription({ NAME: L10n.elideIfLong(node.nodeName) }),
      paramsForAction: { nodeId: node.nodeId},
      actionName: Messages.confirm(),
      action: () => {
        return  BaasEdgePoolAndCluster.approveClusterNode({siteId: siteId, clusterId: clusterId, nodeId: node.nodeId})
        .then((result: IApproveClusterNodeResult) => {
          props.refreshBaasEdgePools();
          if (result.success) {
            ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsAcceptClusterNodeSuccess({ NODE_NAME: L10n.elideIfLong(node.nodeName) }) });
          }
          if (result.errors) {
            ToasterService.instance.pop({
              type: ToastType.Error,
              text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message),
              actionMessage: Messages.dataConnectSiteSettingsLearnMore(),
              actionHref: HelpService.getServerHelpUrlByCategory('DataConnect-ClustersAndNodes')
            });
          }
          return Promise.resolve();
        });
      },
      isActionDelete: false,
      dialogWidth: TabDialogWidth.width375px
    });

    return Promise.resolve(dialogInstance.result);
  }
